import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "11",
  height: "10",
  fill: "none",
  viewBox: "0 0 11 10"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M.906.273a.646.646 0 0 0 0 .899L4.742 5 .906 8.836a.637.637 0 0 0 0 .89c.25.243.657.243.89 0l3.837-3.835L9.46 9.727c.242.242.656.25.898 0 .235-.25.235-.657 0-.891L6.523 5l3.836-3.828a.654.654 0 0 0 0-.899.66.66 0 0 0-.898 0L5.633 4.11 1.797.273a.644.644 0 0 0-.89 0"
    }, null, -1)
  ])))
}
export default { render: render }